import { createAction, props } from '@ngrx/store';

const GET_SAMPLEDATA = '[SampleData] Get SampleData';
const TRIGGER_SAMPLEDATA = '[SampleData] Trigger SampleData';
const SET_SAMPLEDATA = '[SampleData] Set SampleData';
const SAVE_SAMPLEDATA = '[SampleData] Save SampleData';
const DELETE_SAMPLEDATA = '[SampleData] Delete SampleData';

const getSampleData = createAction(GET_SAMPLEDATA, props<{ apiConstants: any }>());

const triggerSampleData = createAction(TRIGGER_SAMPLEDATA, props<{ apiConstants: any }>());

const setSampleData = createAction(SET_SAMPLEDATA, props<{ sampleDataTable: any }>());

const saveSampleData = createAction(SAVE_SAMPLEDATA, props<{ saveapiConstants: any; sampleData: any }>());

const deleteSampleData = createAction(DELETE_SAMPLEDATA, props<{ deleteApiConstants: any; sampleDataIds: any }>());

export { getSampleData, setSampleData, saveSampleData, deleteSampleData, triggerSampleData };
